export default "__VITE_ASSET__Cr9tCK3g__"